module.exports = __webpack_public_path__ + "img/logo.34d465c6.svg";